import { render } from "./loader.vue?vue&type=template&id=651e2168"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=651e2168&lang=less"
const cssModules = {}
import style1 from "./loader.vue?vue&type=style&index=1&id=651e2168&module=true&lang=css"
cssModules["$style"] = style1
/* custom blocks */
import block0 from "./loader.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__